import { Box, Button, Link } from '@domain-group/suit-theme'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencilAlt } from '@fortawesome/pro-light-svg-icons'

import type { CampaignModel, OrderItemTaskModel } from '@models/types'

import EnabledPermission from '@components/EnabledPermission'

import { getCampaignType } from '@functions/campaign'

interface OrderItemTaskProps {
  boxProps?: object,
  itemPayload: {
    callbacks: {
      manageTasks: VoidFunction,
    },
    campaign: CampaignModel,
    filteredOrderItemTasks: OrderItemTaskModel[],
  },
}

const OrderItemTask = (props: OrderItemTaskProps) => {
  const {
    boxProps,
    itemPayload: {
      callbacks: {
        manageTasks,
      },
      campaign,
      filteredOrderItemTasks,
    },
  } = props

  const taskCount = filteredOrderItemTasks.length

  return (
    <Box
      alignItems="center"
      backgroundColor="white"
      borderRadius={5}
      border="1px dashed"
      borderColor="lineColor"
      justifyContent="space-between"
      padding="large"
      {...boxProps}
    >
      <Link
        onClick={() => manageTasks()}
        textProps={{ color: 'bodyFontLightColor', fontSize: 'xsmall' }}
      >
        View ({taskCount}) {taskCount === 1 ? 'Task' : 'Tasks'}
      </Link>

      <EnabledPermission
        campaignType={getCampaignType(campaign)}
        permissionKey="campaign.tasks.manage"
      >
        <Button
          buttonStyle="secondaryCreate"
          icon={<FontAwesomeIcon icon={faPencilAlt} />}
          onClick={() => manageTasks()}
          size="small"
          width="auto"
        >
          Manage Tasks
        </Button>
      </EnabledPermission>
    </Box>
  )
}

export default OrderItemTask
